<template>
    <div id="popup"
        v-bind:okanMain="okanMain"
        v-bind:appartData="appartData"
        v-show="appartData != null"
        @click="showAppart"
    >
      <div id="flefleche"></div>
      <div id="popupContainer">
        
        <div id="title"><span>Lot : <br v-if="appartData.appartName.length > 5"/><span class="unbreakable">{{appartData.appartName}}</span></span></div>

        <div id="type"><span>{{appartData.type}}</span></div>

        <button 
          id="showAppart" 
         v-show="!appartData.ksos" 
          
          v-bind:class="{'notAllowed' : appartData.ksos}" 
        >Visiter</button>
      </div>

    </div>

</template>

<script>


export default {
  name: 'popup',
  props:{
      okanMain: Object,
      appartData : Object
  },
  data() {
    return {

    }
  },
  methods: {
    showAppart(){
      if( !this.appartData.ksos) //this.appartData.sphereID !=null &&
          this.okanMain.clickOnAppart();
    }
  },
  mounted() {

  },
  watch:{
      appartData:{
          immediate: true,
          deep:true,
          handler(){
            this.okanMain.setPopup()              
          }
      }
  }
}
</script>

<style src="../assets/css/popup.css"></style>